import React, { useContext, useEffect, useRef } from "react";
import {withRouter} from "next/router";
import {Box, ResponsiveContext, Text} from "grommet";
import NextAnchor from "./NextAnchor";
import { isActive } from "../utils/router";

/*
    On a phone each tab sizes to its label: four at their 96px minimum overflowed a 412px
    screen and cut the last one off. Labels never wrap, so on anything narrower the row
    scrolls rather than folding "Plans & Billing" onto two lines.
*/
const NavButton = ({ label, active, replace, ...rest }) => {
    const isSmall = useContext(ResponsiveContext) === 'small';
    return (
        <NextAnchor
            label={(
                <Box
                    width={isSmall ? undefined : { min: 'xsmall' }}
                    pad={{ vertical: 'xxsmall', horizontal: isSmall ? '10px' : 'xsmall' }}
                    responsive={false}
                    align="center"
                    border={{ side: 'bottom', size: 'small', color: active ? 'brand' : 'border-strong' }}
                >
                    <Text size="small" style={{ whiteSpace: 'nowrap' }}>{label}</Text>
                </Box>
            )}
            margin={{ vertical: 'xxsmall', horizontal: 'xxsmall' }}
            style={{ flexShrink: 0 }}
            size="small"
            plain
            hoverIndicator
            button
            replace={replace}
            aria-current={active ? 'page' : undefined}
            {...rest}
        />
    );
};

const SubMenu = ({ items, router, replace, ...rest}) => {
    const rowRef = useRef();

    // When the row scrolls, bring the current tab into view so the page shows where it is
    useEffect(() => {
        const row = rowRef.current;
        const tab = row?.querySelector('[aria-current="page"]');
        if (!tab) return;
        const right = tab.offsetLeft + tab.offsetWidth;
        if (right > row.scrollLeft + row.clientWidth) row.scrollLeft = right - row.clientWidth;
        else if (tab.offsetLeft < row.scrollLeft) row.scrollLeft = tab.offsetLeft;
    }, [router.asPath]);

    return (
        <Box ref={rowRef} data-testid="submenu" direction="row" responsive={false} flex={false} gap="xxsmall" margin={{ bottom: 'small' }} overflow={{ horizontal: 'auto' }} style={{ position: 'relative' }} {...rest}>
            {items.map((item) =>
                <NavButton
                    key={item.label}
                    // A hash or query (#payment-method, ?action=edit) is still the same tab
                    active={[router.asPath, router.asPath.split(/[?#]/)[0]].some(path => isActive(item.href, path, item?.regExp, item?.exclude))}
                    href={item.href}
                    replace={replace}
                    label={item.label} />
            )}
        </Box>
    );
};

export default withRouter(SubMenu);
